export default ({request}) => ({
  ecomAmzRecordStoreListApi(data = {}) {
    return request({
      url: '/ecom/ecomAmzRecordStore/list',
      method: 'POST',
      data,
    })
  },
})
